const selectedPolicesActions = {
  SERVICE_REQUEST_POLICIES_SELECTED: 'SERVICE_REQUEST_POLICIES_SELECTED',
};

export default selectedPolicesActions;
